/*
 * דמי משלוח בעגלה — מושך את תעריף המשלוח האמיתי מהגדרות השילוח של שופיפיי
 * (Shopify Shipping) דרך /cart/shipping_rates.json ומציג אותו בשורת "דמי משלוח".
 * אם החנות מזכה במשלוח חינם — Liquid כבר מציג "חינם" (לפי סף התבנית).
 * אם משהו נכשל — נשארת ברירת המחדל "יחושבו בקופה", בלי לשבור כלום.
 *
 * ===== יעד ברירת מחדל (עריכה במידת הצורך) =====
 */
(function () {
  "use strict";

  var SHIP_COUNTRY = "Israel"; // שם המדינה לחישוב התעריף
  var SHIP_ZIP = ""; // מיקוד — אופציונלי; מלא אם השילוח בשופיפיי דורש מיקוד

  var cachedRate = null; // תעריף המשלוח בתשלום (יחידות מלאות), null = לא ידוע עדיין
  var fetching = false;
  var failed = false;
  var debounce;

  function group(num, decimals) {
    var s = decimals ? Number(num).toFixed(2) : String(Math.round(num));
    var parts = s.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  function formatMoney(amount) {
    // Match the store's own money format (same as subtotal) when available
    var fmt = window.__WT_MONEY_FORMAT;
    if (fmt && typeof fmt === "string") {
      fmt = fmt.replace(/<[^>]+>/g, ""); // strip any HTML in the format
      return fmt
        .replace(/\{\{\s*amount\s*\}\}/g, group(amount, true))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(amount, false))
        .replace(
          /\{\{\s*amount_with_comma_separator\s*\}\}/g,
          group(amount, true).replace(/,/g, " ").replace(/\./g, ",")
        )
        .replace(
          /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
          group(amount, false).replace(/,/g, " ")
        )
        .trim();
    }
    try {
      var cur =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        "ILS";
      var lang = document.documentElement.getAttribute("lang") || "he-IL";
      return new Intl.NumberFormat(lang, {
        style: "currency",
        currency: cur,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (e) {
      return "₪" + amount;
    }
  }

  function fillLines() {
    var nodes = document.querySelectorAll(
      "[data-shipping-estimate]:not([data-shipping-filled])"
    );
    if (!nodes.length) return;

    if (cachedRate != null) {
      nodes.forEach(function (n) {
        n.textContent = formatMoney(cachedRate);
        n.classList.remove("wt-cart__shipping-line__value--muted");
        n.setAttribute("data-shipping-filled", "");
      });
      return;
    }
    if (!failed) fetchRate();
  }

  function fetchRate() {
    if (fetching || failed || cachedRate != null) return;
    fetching = true;

    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var url =
      root +
      "cart/shipping_rates.json?shipping_address[country]=" +
      encodeURIComponent(SHIP_COUNTRY) +
      (SHIP_ZIP ? "&shipping_address[zip]=" + encodeURIComponent(SHIP_ZIP) : "");

    fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error("http " + r.status);
        return r.json();
      })
      .then(function (data) {
        var rates = (data && data.shipping_rates) || [];
        // cheapest PAID rate (a free rate is handled server-side, shown as "חינם")
        var paid = rates
          .map(function (x) {
            return parseFloat(x.price);
          })
          .filter(function (p) {
            return !isNaN(p) && p > 0;
          });
        fetching = false;
        if (paid.length) {
          cachedRate = Math.min.apply(null, paid);
          fillLines();
        }
        // if no paid rate now (cart already free), leave the fallback; will retry later
      })
      .catch(function () {
        failed = true;
        fetching = false;
      });
  }

  function schedule() {
    window.clearTimeout(debounce);
    debounce = window.setTimeout(fillLines, 60);
  }

  function boot() {
    fillLines();
    try {
      new MutationObserver(schedule).observe(document.body, {
        childList: true,
        subtree: true,
      });
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
